module.exports = __webpack_public_path__ + "img/img-7.0d7f4ab3.png";